import { render, staticRenderFns } from "./Microelement.vue?vue&type=template&id=8a2b253e&scoped=true"
import script from "./Microelement.vue?vue&type=script&lang=js"
export * from "./Microelement.vue?vue&type=script&lang=js"
import style0 from "./Microelement.vue?vue&type=style&index=0&id=8a2b253e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a2b253e",
  null
  
)

export default component.exports